import { Modal } from 'bootstrap';
import { Input } from 'mdb-ui-kit';


if( theme.pre_register === 'false' ){

    let register_modal_open = false;

    window.addEventListener("load", function(){
    
    var classname = document.querySelectorAll(".is-register-button a, .is-register-button");

        for (var i = 0; i < classname.length; i++) {
    
            classname[i].addEventListener('click', build_pre_register_modal, false);
    
        }
    
    });
    
    function build_pre_register_modal( event ){

        event.preventDefault();

        if( register_modal_open ){
            return;
        }

        register_modal_open = true;
        
        let modal_id = makeid(5);
        let register_interest_form_submitted = false;

        const modal = document.createElement("div");
            modal.classList.add('modal', 'fade', 'modal-register-interest');
            modal.setAttribute('id', modal_id );
            modal.setAttribute('tabindex', '-1');
            modal.setAttribute('aria-labelledby', modal_id + 'Label');
            modal.setAttribute('aria-hidden', 'true');

            const modal_dialog = document.createElement("div");
                    modal_dialog.classList.add('modal-dialog', 'modal-dialog-centered');

                    const modal_content = document.createElement("div");
                        modal_content.classList.add('modal-content');

                        const modal_header = document.createElement("div");
                            modal_header.classList.add('modal-header');

                                const modal_title = document.createElement("h2");
                                    modal_title.classList.add('modal-title');

                                    // const modal_title_text = document.createTextNode("Register your interest");
                                    const modal_title_text = document.createTextNode("Registration is not open yet");
                                    modal_title.appendChild(modal_title_text);
            

                                modal_header.append( modal_title );   

  


                                const modal_close= document.createElement("button");
                                    modal_close.classList.add('btn-close');
                                    modal_close.setAttribute('type', 'button');
                                    modal_close.setAttribute('data-bs-dismiss', 'modal');
                                    modal_close.setAttribute('aria-label', 'Close');

                                    const modal_close_icon = document.createElement("i");
                                    modal_close_icon.classList.add('fal');
                                    modal_close_icon.classList.add('fa-times-circle');
                                    modal_close_icon.classList.add('close-icon');
                                    modal_close.append( modal_close_icon );   

                                    
                                
                                modal_header.append( modal_close );   


                        modal_content.append( modal_header );   



                        const modal_body = document.createElement("div");
                            modal_body.classList.add('modal-body');

                            const modal_subtitle = document.createElement("p");
                            modal_subtitle.classList.add('modal-subtitle');

                            // const modal_subtitle_text = document.createTextNode("Register your interest");
                            const modal_subtitle_text = document.createTextNode("Please register your interest to be notified when registration opens");
                            modal_subtitle.appendChild(modal_subtitle_text);
    

                            modal_body.append( modal_subtitle ); 


                                const register_interest_form = document.createElement("form");
                                register_interest_form.setAttribute('novalidate', 'novalidate');
                                register_interest_form.classList.add('needs-validation', 'g-3');
                    
                                const div_error_messages = document.createElement("div");
                                div_error_messages.classList.add('error-messages');

                                
                                register_interest_form.append( div_error_messages );   

                                
                                const div_full_name = document.createElement("div");
                                div_full_name.classList.add('form-outline', 'mb-3');

                                // Create Email
                                const input_full_name = document.createElement("input");
                                    input_full_name.classList.add('form-control', 'form-control-lg' );
                                    input_full_name.setAttribute('type', 'text');
                                    input_full_name.setAttribute('id', 'full_name');
                                    input_full_name.setAttribute('name', 'full_name');
                                    input_full_name.setAttribute('required', 'required');
                
                                div_full_name.appendChild(input_full_name);
                
                                // Create Email Label
                                const label_full_name = document.createElement("label");
                                    label_full_name.classList.add('form-label');
                                    label_full_name.setAttribute('for', 'full_name');
                
                                    const label_full_name_text = document.createTextNode("Name");
                                    label_full_name.appendChild(label_full_name_text);
                                
                                div_full_name.appendChild(label_full_name);
                
                
                                // Create Email Error Label
                                const validation_error_full_name = document.createElement("div");
                                    validation_error_full_name.classList.add('invalid-feedback');
                
                                    const validation_error_full_name_text = document.createTextNode("You must provide your name");
                                    validation_error_full_name.appendChild(validation_error_full_name_text);
                
                                div_full_name.appendChild(validation_error_full_name);

                                
                                const div_email_address = document.createElement("div");
                                    div_email_address.classList.add('form-outline', 'mb-3');
                    
                                    // Create Email
                                    const input_email_address = document.createElement("input");
                                        input_email_address.classList.add('form-control', 'form-control-lg' );
                                        input_email_address.setAttribute('type', 'email');
                                        input_email_address.setAttribute('id', 'email_address');
                                        input_email_address.setAttribute('name', 'email_address');
                                        input_email_address.setAttribute('required', 'required');
                    
                                    div_email_address.appendChild(input_email_address);
                    
                                    // Create Email Label
                                    const label_email_address = document.createElement("label");
                                        label_email_address.classList.add('form-label');
                                        label_email_address.setAttribute('for', 'email_address');
                    
                                        const label_email_address_text = document.createTextNode("Email Address");
                                        label_email_address.appendChild(label_email_address_text);
                                    
                                    div_email_address.appendChild(label_email_address);
                    
                    
                                    // Create Email Error Label
                                    const validation_error_email_address = document.createElement("div");
                                        validation_error_email_address.classList.add('invalid-feedback');
                    
                                        const validation_error_email_address_text = document.createTextNode("You must provide a valid email address");
                                        validation_error_email_address.appendChild(validation_error_email_address_text);
                    
                                    div_email_address.appendChild(validation_error_email_address);
                                
                                
                                    const div_company = document.createElement("div");
                                        div_company.classList.add('form-outline', 'mb-3');

                                        // Create Email
                                        const input_company = document.createElement("input");
                                            input_company.classList.add('form-control', 'form-control-lg' );
                                            input_company.setAttribute('type', 'text');
                                            input_company.setAttribute('id', 'company');
                                            input_company.setAttribute('name', 'company');
                                            input_company.setAttribute('required', 'required');
                        
                                        div_company.appendChild(input_company);
                        
                                        // Create Email Label
                                        const label_company = document.createElement("label");
                                            label_company.classList.add('form-label');
                                            label_company.setAttribute('for', 'company');
                        
                                            const label_company_text = document.createTextNode("Company");
                                            label_company.appendChild(label_company_text);
                                        
                                        div_company.appendChild(label_company);
                        
                        
                                        // Create Email Error Label
                                        const validation_error_company = document.createElement("div");
                                            validation_error_company.classList.add('invalid-feedback');
                        
                                            const validation_error_company_text = document.createTextNode("You must provide your company name");
                                            validation_error_company.appendChild(validation_error_company_text);
                        
                                        div_company.appendChild(validation_error_company);


                                        // I am interested in attending as a Delegate
                                        // I am interested in Exhibiting / Sponsoring 

                        

                                        // Create 
                                        const div_interest = document.createElement("div");
                                        div_interest.classList.add('form-check', 'mb-3');

                                            // Create Email
                                            const input_interest = document.createElement("input");
                                                input_interest.classList.add('form-check-input' );
                                                input_interest.setAttribute('type', 'checkbox');
                                                input_interest.setAttribute('id', 'interest');
                                                input_interest.setAttribute('name', 'interest');
                                                input_interest.setAttribute('value', '1');
                            
                                            div_interest.appendChild(input_interest);
                                            
                                            // Create Email Label
                                            const label_interest = document.createElement("label");
                                                label_interest.classList.add('form-check-label');
                                                label_interest.setAttribute('for', 'interest');
                            
                                                const label_interest_text = document.createTextNode("I am interested in attending as a Delegate");
                                                label_interest.appendChild(label_interest_text);
                                            
                                            div_interest.appendChild(label_interest);
                        

                                        // Create 
                                        const div_sponsor_opportunities = document.createElement("div");
                                        div_sponsor_opportunities.classList.add('form-check', 'mb-3');

                                            // Create Email
                                            const input_sponsor_opportunities = document.createElement("input");
                                                input_sponsor_opportunities.classList.add('form-check-input' );
                                                input_sponsor_opportunities.setAttribute('type', 'checkbox');
                                                input_sponsor_opportunities.setAttribute('id', 'sponsor_opportunities');
                                                input_sponsor_opportunities.setAttribute('name', 'sponsor_opportunities');
                                                input_sponsor_opportunities.setAttribute('value', '1');
                            
                                            div_sponsor_opportunities.appendChild(input_sponsor_opportunities);
                                            
                                            // Create Email Label
                                            const label_sponsor_opportunities = document.createElement("label");
                                                label_sponsor_opportunities.classList.add('form-check-label');
                                                label_sponsor_opportunities.setAttribute('for', 'sponsor_opportunities');
                            
                                                const label_sponsor_opportunities_text = document.createTextNode("I am interested in Exhibiting / Sponsoring");
                                                label_sponsor_opportunities.appendChild(label_sponsor_opportunities_text);
                                            
                                            div_sponsor_opportunities.appendChild(label_sponsor_opportunities);
                        

                                        const div_email_consent = document.createElement("div");
                                        div_email_consent.classList.add('form-check', 'mb-3');

                                            // Create Email
                                            const input_email_consent = document.createElement("input");
                                                input_email_consent.classList.add('form-check-input' );
                                                input_email_consent.setAttribute('type', 'checkbox');
                                                input_email_consent.setAttribute('id', 'email_consent');
                                                input_email_consent.setAttribute('name', 'email_consent');
                                                input_email_consent.setAttribute('required', 'required');
                                                input_email_consent.setAttribute('value', '1');
                            
                                            div_email_consent.appendChild(input_email_consent);
                                            
                                            // Create Email Label
                                            const label_email_consent = document.createElement("label");
                                                label_email_consent.classList.add('form-check-label');
                                                label_email_consent.setAttribute('for', 'email_consent');
                            
                                                const label_email_consent_text = document.createTextNode("I confirm my email can be stored in order to contact me");
                                                label_email_consent.appendChild(label_email_consent_text);
                                            
                                            div_email_consent.appendChild(label_email_consent);
                        

                    
                                        // Create Submit Button
                                        const div_submit = document.createElement("div");
                                            div_submit.classList.add('d-grid', 'gap-2');

                                        const button_submit = document.createElement("button");
                                            button_submit.setAttribute('type', 'submit');
                                            button_submit.classList.add('btn', 'btn-lg', 'btn-secondary', 'register-btn');

                                            const button_span_submit = document.createElement("span");
                                            button_span_submit.setAttribute('role', 'status');
                                            button_span_submit.setAttribute('aria-hidden', 'true');

                                            button_submit.appendChild(button_span_submit);

                                            // const button_submit_text = document.createTextNode("Submit");
                                            const button_submit_text = document.createTextNode("Register");
                                            button_submit.appendChild(button_submit_text);



                                            div_submit.appendChild(button_submit);

            

                
                
                                // Add to form 
                                register_interest_form.appendChild(div_full_name);
                                register_interest_form.appendChild(div_email_address);
                                register_interest_form.appendChild(div_company);
                                register_interest_form.appendChild(div_interest);
                                register_interest_form.appendChild(div_sponsor_opportunities);
                                register_interest_form.appendChild(div_email_consent);
                                register_interest_form.appendChild(div_submit);
                                
                                
                                modal_body.append( register_interest_form );   

                                modal_content.append( modal_body );   

                                


                        modal_dialog.append( modal_content );   


                    modal.append( modal_dialog );   



        document.body.append( modal );   
        re_init_inputs();


        // On submit the form
        register_interest_form.onsubmit = function( event ){
                                        
            event.preventDefault();
            event.stopPropagation();

            if( register_interest_form_submitted ){
                return;
            }


            if ( ! register_interest_form.checkValidity() ) {

                register_interest_form_submitted = false;

                if( ! input_full_name.checkValidity() ){

                    div_full_name.classList.add( 'mb-5');
        
                } else {
        
                    div_full_name.classList.remove( 'mb-5');
        
                }


                if( ! input_email_address.checkValidity() ){

                    div_email_address.classList.add( 'mb-5');
        
                } else {
        
                    div_email_address.classList.remove( 'mb-5');
        
                }
        
                if( ! input_company.checkValidity() ){
        
                    div_company.classList.add( 'mb-5');
        
                } else {
        
                    div_company.classList.remove( 'mb-5');
        
                }
        
                if( ! input_email_consent.checkValidity() ){
        
                    div_email_consent.classList.add( 'mb-5');
        
                } else {
        
                    div_email_consent.classList.remove( 'mb-5');
        
                }
        


            } 

            if ( register_interest_form.checkValidity() ) {

                // Send the data to wordpress.

                grecaptcha.ready(function() {

                    grecaptcha.execute( reCAPTCHA.site_key , {action: 'submit'}).then(function(token) {


                        var form = document.querySelector('.modal form');

                        var form_data = new FormData( form );
                        form_data.append( 'response', token);
                        form_data.append( 'action', 'register_your_interest_form');
                        console.log( ... form_data, 't', theme.ajax );


                        jQuery.ajax({
                            type: 'POST',
                            contentType: false,
                            processData: false,
                            url: theme.ajax,
                            data: form_data,
                        
                            
                            beforeSend : function(){

                                // Clear the error messages
                                if( div_error_messages.firstChild ){
                                    while(div_error_messages.firstChild && div_error_messages.removeChild(div_error_messages.firstChild));
                                }

                                // Set button to spinner         
                                button_submit.removeChild(button_submit_text);
                                button_submit.setAttribute('disabled', 'disabled');
                                
                                button_span_submit.classList.add('spinner-border', 'spinner-border-sm'); ///

                            },
                            
                            success: function( response ){

                                response = JSON.parse( response );
                                        
                                if( response.success ){

                                    // button_submit.appendChild(button_submit_text);

                                    register_interest_form.classList.add('d-none');
                                    register_interest_form.remove();


                                    const success_message = document.createElement("p");
                                    success_message.classList.add('success-message');

                                    const success_message_text = document.createTextNode( response.success_message );
                                    success_message.appendChild(success_message_text);

                                    // Change the title
                                    const success_message_title = document.createTextNode( response.success_title );

                                    // Clear the title
                                    modal_title.removeChild(modal_title.firstChild);

                                    // Add new title
                                    modal_title.appendChild(success_message_title);

                                    // Append the message
                                    modal_body.appendChild(success_message);

                                }
                                

                                if( response.success == false ){

                                    let error_message = document.createElement("p");
                                    error_message.classList.add('error-message', 'mb-3');

                                    let error_message_text = document.createTextNode( response.error_codes );
                                    error_message.appendChild(error_message_text);

                                    div_error_messages.appendChild( error_message );   



                                    // Reset the button 

                                    button_submit.removeAttribute('disabled');
                                    button_span_submit.classList.remove('spinner-border', 'spinner-border-sm');

                                }

                            }

                        });
                        
                    });

                  });


            }

            register_interest_form.classList.add('was-validated');

        }


        // Open the Modal 
        let modal_js = new Modal( document.getElementById(modal_id  ), {  backdrop : false } );

        modal_js.show();

        // Remove the Modal if shut
        modal.addEventListener('hidden.bs.modal', function (event) {

            document.getElementById( modal_id ).remove();
            register_modal_open = false;

        });


        // On show re-inti inputs
        modal.addEventListener('show.bs.modal', function (event) {

            re_init_inputs();
        
        });

    }

}

function re_init_inputs(){

    document.querySelectorAll('.form-outline').forEach((input) => {

        new Input( input ).init();

    });  
}

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}
